import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { runSaga } from 'redux-saga';
import { call } from 'redux-saga/effects';
import apiSaga from '../store/api';
import createChallengeSession from '../utils/challengeSession';

export default function useChallengeSession({ url }) {
  const dispatch = useDispatch();
  const urlRef = useRef(url);
  const mounted = useRef(true);
  const controller = useRef(null);
  const [status, setStatus] = useState({ active: false, saving: false, error: null });
  urlRef.current = url;
  if (!controller.current) {
    controller.current = createChallengeSession({
      getUrl: () => urlRef.current,
      onChange: (next) => { if (mounted.current) setStatus(next); },
      send: async (endpoint, data) => {
        const response = await runSaga({ dispatch }, function* request() {
          return yield call(apiSaga, {
            method: 'POST', url: endpoint, data, timeout: 15000,
          });
        }).toPromise();
        return response?.data;
      },
    });
  }
  useEffect(() => () => {
    mounted.current = false;
    controller.current.stop().catch(() => {});
  }, []);
  return { ...controller.current, ...status };
}
